import { render, staticRenderFns } from "./VueAwesomeIcon.vue?vue&type=template&id=6c16f75c&"
import script from "./VueAwesomeIcon.vue?vue&type=script&lang=ts&setup=true&"
export * from "./VueAwesomeIcon.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports